import CardLists from '@/components/CardLists/CardLists'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import Tabs from '@/components/Tabs/Tabs'
import { GenericPageProps } from '@/types/page'
import { serverSidePropsFor } from '@/utils/helpers.server'

const PartnersPage = ({ data }: GenericPageProps) => (
  <Main>
    <DefaultHead data={data} />
    <SimpleHeader>{data.header}</SimpleHeader>
    <Tabs />
    <CardLists hideSidebar initCardLists={data.container.json_dict.cardlists} />
  </Main>
)

export const getServerSideProps = async () =>
  serverSidePropsFor(`${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/companions.json`)

export default PartnersPage
